import { API_URL_MAIN } from '@/config';
import { axios } from '@/lib/axios';

export type I_ChangePasswordInfo = {
  password: string;
  new_password: string;
};

export const changePassword = (data: I_ChangePasswordInfo): Promise<I_ChangePasswordInfo> => {
  return axios.post(`${API_URL_MAIN}/change_password`, data,
  );
};
